/** Стиль-пак «soft-rounded» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'soft-rounded',
  shape: {
    radiusCard: 20, radiusOption: 20, radiusButton: 'pill', radiusImage: 16,
    borderWidth: 1, borderTone: 'brand-soft', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 58, optionPadY: 14, optionPadX: 16, gap: 12, contentMaxWidth: 560, screenPadX: 20 },
  type: {
    headingFamily: 'sans', h1Size: 36, h1Weight: 700, h1Tracking: -0.9,
    qSize: 24, qWeight: 700, qTracking: -0.6, optionSize: 16, optionWeight: 400,
    headingAlign: 'center', overlineTransform: 'uppercase',
  },
  chrome: { progress: 'segmented', progressLabel: 'center', counter: false, backButton: 'pill', logo: 'center' },
  cta: { placement: 'sticky-bottom', fullWidth: true, height: 60, disabledStyle: 'muted-brand' },
  states: { selected: 'brand-border-tint', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-overlay-bottom', overlayTone: 'brand', frame: 'rounded',
    promptHint: 'clean 3D avatar or friendly illustration on plain light background',
  },
  // Визард 12min: прогресс и вопрос сразу под шапкой, sticky-CTA внизу —
  // контент живёт у верха по центру, поэтому фон гасится ровной вуалью.
  layout: { alignY: 'top', alignX: 'center', backgroundOverlay: 'scrim-full' },
  // 12min: стадии стекаются с чек-бейджами, на ~49% каждой всплывает
  // модалка-вопрос и прогресс ждёт ответа; прелоадер до опенера с процентом.
  loader: {
    style: 'stacked-stages', showPercent: true, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // 12min целиком: моно-таймер резерва в sticky-хедере с дублем CTA, зелёный
  // перфорированный тикет «код применён», цена за месяц с зачёркнутой старой,
  // чип Most Popular НА рамке, повтор блока покупки после отзывов и FAQ.
  // Невыбранные тарифы не гасятся — выбранный держится тенью (SYNTHESIS §9).
  paywall: {
    timer: 'mono-header', promoTicket: 'perforated', priceMode: 'per-month',
    planHighlight: 'chip-on-border', dimUnselectedPlans: false,
    stickyHeader: true, repeatPurchaseBlock: true,
  },
  // Эталон двухцветности: зелёный = деньги и безопасность, золото = премиум.
  accents: { money: 'success', premium: 'accent' },
};
